// Signed-in session. Two providers: Privy (email only, embedded wallets OFF, lazy-loaded so
// guests never download it) and a dev email login for local testing.
import { signal } from "@preact/signals";
import { clientEnv } from "./env";

export interface Session {
  provider: "privy" | "dev";
  email: string | null;
  userId?: string;
  handle?: string | null;
  isAdmin?: boolean;
  cosmetics?: string[];
}

export const session = signal<Session | null>(null);
const DEV_KEY = "degen-world:devtoken";

let privyGetToken: (() => Promise<string | null>) | null = null;
export function setPrivyTokenGetter(fn: (() => Promise<string | null>) | null) {
  privyGetToken = fn;
}

export async function authToken(): Promise<string | null> {
  if (session.value?.provider === "privy" && privyGetToken) return privyGetToken();
  try {
    return localStorage.getItem(DEV_KEY);
  } catch {
    return null;
  }
}

export function saveDevToken(token: string | null) {
  try {
    if (token) localStorage.setItem(DEV_KEY, token);
    else localStorage.removeItem(DEV_KEY);
  } catch {
    /* ignore */
  }
}

export const canSignIn = () => !!clientEnv.apiUrl && (!!clientEnv.privyAppId || clientEnv.devAuth);
